import mixinMutations from '@/store/mixins/rule/mutations'
import mixinActions from '@/store/mixins/rule/actions'
import mixinGetters from '@/store/mixins/rule/getters'

export default {
	namespaced: true,
	state: {
		all: {},
		removed: [],
		notValid: []
	},
	getters: {
		...mixinGetters,
		editSource (state, getters, rootState, rootGetters) {
			return rootGetters.editSources.survey
		}
	},
  mutations: mixinMutations,
	actions: {
		...mixinActions
	},
}
